<template>
    <div class="join-code-qr text-center">
        <canvas ref="canvas"></canvas>
        <div class="join-code-qr-text">{{ effective_code || '------' }}</div>
    </div>
</template>

<script>
import QRCode from 'qrcode'

// Renders fully offline (canvas-based, no calls to any external QR-image
// service) - this runs live at in-person events where venue wifi can't be
// relied on. Used in Panel.vue's admin modal, Home.vue's projected "big
// screen" (MANAGER role, whole-event code) and Stages.vue's per-stage QR
// modal (via the `code` prop, overriding the whole-event join_code).
//
// The QR always encodes an absolute URL, not a path - a phone camera has no
// "current origin" to resolve a relative one against. window.location.origin
// is normally right (same tab that's projecting the QR is the one serving
// it), EXCEPT behind a tunnel: if the manager's own browser is open on
// http://localhost:8080 while ngrok exposes that same app at a different
// public https URL, the QR would encode "localhost" - useless to any other
// device. VUE_APP_PUBLIC_URL (see .env.ngrok) overrides it for exactly that
// case.
export default {
    name: 'JoinCodeQR',
    props: {
        size: {
            type: Number,
            default: 220,
        },
        code: {
            type: String,
            default: null,
        },
        // Which join route this code belongs to - '/join' (EVENT mode's
        // whole-game/per-stage code, Auth.vue) by default, '/join-season'
        // for ONLINE mode's per-season code (JoinSeason.vue). Same rendering
        // either way, just a different landing page for the scanned URL.
        path: {
            type: String,
            default: '/join',
        }
    },
    computed: {
        effective_code(){
            return this.code || this.$store.state.game.join_code;
        }
    },
    watch: {
        effective_code(){ this.render(); },
        path(){ this.render(); },
        size(){ this.render(); }
    },
    mounted(){
        this.render();
    },
    methods: {
        render(){
            const code = this.effective_code;
            const canvas = this.$refs.canvas;
            if (!canvas) return;
            if (!code) { canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height); return; }

            const base_url = (process.env.VUE_APP_PUBLIC_URL || window.location.origin).replace(/\/$/, '');
            const join_url = base_url + this.path + '/' + code;
            QRCode.toCanvas(canvas, join_url, { width: this.size, margin: 1 }, function(err){
                if(err) console.error(err);
            });
        }
    }
}
</script>

<style scoped>
    .join-code-qr-text{
        font-family: "Archivo", sans-serif;
        font-weight: 800;
        font-size: 1.8rem;
        letter-spacing: 0.15em;
        margin-top: 0.75rem;
    }
</style>
